import { handleFormShortcutKeyDown } from '@/lib/form-shortcuts'
import { useEffect } from 'react'

/** Installs the app-wide Cmd/Ctrl+Enter (submit) and Esc (cancel) form shortcuts. Mount once at the app root. */
export const useFormShortcuts = () => {
  useEffect(() => {
    // Bubble phase on document, so component-level handlers (React root, ProseMirror, Radix) run first.
    document.addEventListener('keydown', handleFormShortcutKeyDown)
    return () => document.removeEventListener('keydown', handleFormShortcutKeyDown)
  }, [])
}
